<template>
  <info-screen
    :title="t('free-trial-expired.title')"
    :message="t('free-trial-expired.message')"
    :image="TimeImage"
  />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { onMounted, watchEffect } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import TimeImage from '@/assets/time.svg'
import InfoScreen from '@/components/InfoScreen.vue'
import { useAuthStore } from '@/store/auth'

const authStore = useAuthStore()
const { trialExpired } = storeToRefs(authStore)
const router = useRouter()
const { t } = useI18n()

onMounted(() => {
  authStore.refreshBillingStatus()
  if (!trialExpired.value) {
    router.push({
      name: 'employees'
    })
  }
})

watchEffect(() => {
  if (!trialExpired.value) {
    router.push({
      name: 'employees'
    })
  }
})
</script>
